import React from 'react';
import { useIntl } from 'react-intl';
import DonutChart from './DonutChart';
import { SEGMENT_VARS } from './chartTheme';
import messages from '../../../locale/jsonMessages';

const SEGMENT_LABELS = {
  rental: 'orpBreakdownRental', options: 'orpBreakdownOptions', delivery: 'orpBreakdownDelivery', other: 'orpBreakdownOther',
};

// "Breakdown of my revenue": Rental / Options / Delivery (+ Other only when the server returns a non-zero amount), gross amounts.
const RevenueBreakdownDonut = ({ breakdown, total, currency, help }) => {
  const { formatMessage } = useIntl();
  const segments = ['rental', 'options', 'delivery', 'other']
    .map((key) => ({ key, label: formatMessage(messages[SEGMENT_LABELS[key]]), value: Number(breakdown && breakdown[key]) || 0, cssVar: SEGMENT_VARS[key] }))
    .filter((segment) => segment.key !== 'other' || segment.value !== 0);
  return (
    <DonutChart title={formatMessage(messages.orpBreakdownTitle)} help={help} segments={segments} total={total}
      totalLabel={formatMessage(messages.orpBreakdownTotal)} currency={currency} />
  );
};

export default RevenueBreakdownDonut;
